export default __webpack_public_path__ + "static/media/learose4-1440w.f8a7561d.png";